import {combineEpics} from 'web-app/util/redux-observable';

import occupancyPlanner from './occupancy-planner/epics';
import revenueDetails from './revenue-details/epics';

export default combineEpics(occupancyPlanner, revenueDetails);
